import { EEventStatuses } from 'common/const/enums.const';

export const getEventAvailableOperations = (
  status?: string,
  currentUserId?: string,
  assigneeId?: string,
  isRelatedEvent?: boolean
) => {
  let canBeMovedToInbox = false;
  let canBeCompleted = false;
  let canBeHeld = false;
  let canStart = false;
  let canBeOutdated = false;
  let blockAllOperations = false;

  if (isRelatedEvent && status === EEventStatuses.Inbox) {
    canBeCompleted = true;
    canBeHeld = true;
    canBeOutdated = true;
  }

  if (currentUserId && assigneeId && currentUserId === assigneeId && status === EEventStatuses.UnderReview && isRelatedEvent) {
    blockAllOperations = true;
  }

  if (currentUserId && assigneeId && currentUserId === assigneeId && status === EEventStatuses.UnderReview && !isRelatedEvent) {
    canBeMovedToInbox = true;
    canBeCompleted = true;
    canBeHeld = true;
    canStart = true;
    canBeOutdated = true;
  }

  return { canBeMovedToInbox, canBeCompleted, canBeHeld, canStart, canBeOutdated: canBeOutdated, blockAllOperations };
};

export const getEventActionsTooltipTitle = (blockAllOperations: boolean) => {
  return blockAllOperations ? 'This event is already under review' : undefined;
};
